/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addCategoryToMenu } from '../fn/menu/add-category-to-menu';
import { AddCategoryToMenu$Params } from '../fn/menu/add-category-to-menu';
import { addMenuToVenues } from '../fn/menu/add-menu-to-venues';
import { AddMenuToVenues$Params } from '../fn/menu/add-menu-to-venues';
import { createCategory } from '../fn/menu/create-category';
import { CreateCategory$Params } from '../fn/menu/create-category';
import { createMenu } from '../fn/menu/create-menu';
import { CreateMenu$Params } from '../fn/menu/create-menu';
import { createMenuItem } from '../fn/menu/create-menu-item';
import { CreateMenuItem$Params } from '../fn/menu/create-menu-item';
import { createMenuWithCategories } from '../fn/menu/create-menu-with-categories';
import { CreateMenuWithCategories$Params } from '../fn/menu/create-menu-with-categories';
import { createSubCategory } from '../fn/menu/create-sub-category';
import { CreateSubCategory$Params } from '../fn/menu/create-sub-category';
import { createTaxRate } from '../fn/menu/create-tax-rate';
import { CreateTaxRate$Params } from '../fn/menu/create-tax-rate';
import { deleteCategory } from '../fn/menu/delete-category';
import { DeleteCategory$Params } from '../fn/menu/delete-category';
import { deleteMenu } from '../fn/menu/delete-menu';
import { DeleteMenu$Params } from '../fn/menu/delete-menu';
import { deleteMenuItem } from '../fn/menu/delete-menu-item';
import { DeleteMenuItem$Params } from '../fn/menu/delete-menu-item';
import { deleteSubCategory } from '../fn/menu/delete-sub-category';
import { DeleteSubCategory$Params } from '../fn/menu/delete-sub-category';
import { deleteTaxRate } from '../fn/menu/delete-tax-rate';
import { DeleteTaxRate$Params } from '../fn/menu/delete-tax-rate';
import { getDefaultCurrency } from '../fn/menu/get-default-currency';
import { GetDefaultCurrency$Params } from '../fn/menu/get-default-currency';
import { getMostOrderedItems } from '../fn/menu/get-most-ordered-items';
import { GetMostOrderedItems$Params } from '../fn/menu/get-most-ordered-items';
import { getTaxRateDetails } from '../fn/menu/get-tax-rate-details';
import { GetTaxRateDetails$Params } from '../fn/menu/get-tax-rate-details';
import { listAllMenus } from '../fn/menu/list-all-menus';
import { listAllMenus_1 } from '../fn/menu/list-all-menus-1';
import { ListAllMenus_1$Params } from '../fn/menu/list-all-menus-1';
import { ListAllMenus$Params } from '../fn/menu/list-all-menus';
import { listAllSubVenuesForCombo } from '../fn/menu/list-all-sub-venues-for-combo';
import { ListAllSubVenuesForCombo$Params } from '../fn/menu/list-all-sub-venues-for-combo';
import { listAllTaxRates } from '../fn/menu/list-all-tax-rates';
import { ListAllTaxRates$Params } from '../fn/menu/list-all-tax-rates';
import { listCategoryForCompany } from '../fn/menu/list-category-for-company';
import { ListCategoryForCompany$Params } from '../fn/menu/list-category-for-company';
import { listCategoryForMenu } from '../fn/menu/list-category-for-menu';
import { ListCategoryForMenu$Params } from '../fn/menu/list-category-for-menu';
import { listCurrenciesForMenu } from '../fn/menu/list-currencies-for-menu';
import { ListCurrenciesForMenu$Params } from '../fn/menu/list-currencies-for-menu';
import { listItemsForCategory } from '../fn/menu/list-items-for-category';
import { ListItemsForCategory$Params } from '../fn/menu/list-items-for-category';
import { listItemsForCompany } from '../fn/menu/list-items-for-company';
import { ListItemsForCompany$Params } from '../fn/menu/list-items-for-company';
import { listItemsForSubCategory } from '../fn/menu/list-items-for-sub-category';
import { ListItemsForSubCategory$Params } from '../fn/menu/list-items-for-sub-category';
import { listSubCategoryForCategory } from '../fn/menu/list-sub-category-for-category';
import { ListSubCategoryForCategory$Params } from '../fn/menu/list-sub-category-for-category';
import { listSubCategoryForCompany } from '../fn/menu/list-sub-category-for-company';
import { ListSubCategoryForCompany$Params } from '../fn/menu/list-sub-category-for-company';
import { listTaxRatesForCombo } from '../fn/menu/list-tax-rates-for-combo';
import { ListTaxRatesForCombo$Params } from '../fn/menu/list-tax-rates-for-combo';
import { updateCategory } from '../fn/menu/update-category';
import { UpdateCategory$Params } from '../fn/menu/update-category';
import { updateMenu } from '../fn/menu/update-menu';
import { UpdateMenu$Params } from '../fn/menu/update-menu';
import { updateMenuItem } from '../fn/menu/update-menu-item';
import { UpdateMenuItem$Params } from '../fn/menu/update-menu-item';
import { updateMenuWithCategories } from '../fn/menu/update-menu-with-categories';
import { UpdateMenuWithCategories$Params } from '../fn/menu/update-menu-with-categories';
import { updateSubCategory } from '../fn/menu/update-sub-category';
import { UpdateSubCategory$Params } from '../fn/menu/update-sub-category';
import { updateTaxRate } from '../fn/menu/update-tax-rate';
import { UpdateTaxRate$Params } from '../fn/menu/update-tax-rate';
import { viewCategory } from '../fn/menu/view-category';
import { ViewCategory$Params } from '../fn/menu/view-category';
import { viewMenu } from '../fn/menu/view-menu';
import { viewMenu_1 } from '../fn/menu/view-menu-1';
import { ViewMenu_1$Params } from '../fn/menu/view-menu-1';
import { viewMenu_2 } from '../fn/menu/view-menu-2';
import { ViewMenu_2$Params } from '../fn/menu/view-menu-2';
import { ViewMenu$Params } from '../fn/menu/view-menu';
import { viewMenuItem } from '../fn/menu/view-menu-item';
import { ViewMenuItem$Params } from '../fn/menu/view-menu-item';
import { viewSubCategory } from '../fn/menu/view-sub-category';
import { ViewSubCategory$Params } from '../fn/menu/view-sub-category';

@Injectable({ providedIn: 'root' })
export class MenuService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `viewMenu()` */
  static readonly ViewMenuPath = '/api/wtr/Menu/viewmenu';

  /**
   * Get default menu for venue.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `viewMenu()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewMenu$Response(params?: ViewMenu$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return viewMenu(this.http, this.rootUrl, params, context);
  }

  /**
   * Get default menu for venue.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `viewMenu$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewMenu(params?: ViewMenu$Params, context?: HttpContext): Observable<void> {
    return this.viewMenu$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getMostOrderedItems()` */
  static readonly GetMostOrderedItemsPath = '/api/wtr/Menu/getmostordereditems';

  /**
   * Get most ordered items for waiter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMostOrderedItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMostOrderedItems$Response(params?: GetMostOrderedItems$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getMostOrderedItems(this.http, this.rootUrl, params, context);
  }

  /**
   * Get most ordered items for waiter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMostOrderedItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMostOrderedItems(params?: GetMostOrderedItems$Params, context?: HttpContext): Observable<void> {
    return this.getMostOrderedItems$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `viewMenu_1()` */
  static readonly ViewMenu_1Path = '/api/mng/Menu/viewmenu';

  /**
   * Get menu for Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `viewMenu_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewMenu_1$Response(params?: ViewMenu_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return viewMenu_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Get menu for Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `viewMenu_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewMenu_1(params?: ViewMenu_1$Params, context?: HttpContext): Observable<void> {
    return this.viewMenu_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listAllMenus()` */
  static readonly ListAllMenusPath = '/api/mng/Menu/listallmenus';

  /**
   * List all menues for general menager company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAllMenus()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllMenus$Response(params?: ListAllMenus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listAllMenus(this.http, this.rootUrl, params, context);
  }

  /**
   * List all menues for general menager company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAllMenus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllMenus(params?: ListAllMenus$Params, context?: HttpContext): Observable<void> {
    return this.listAllMenus$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createMenu()` */
  static readonly CreateMenuPath = '/api/gmn/Menu/createmenu';

  /**
   * Create menu for venue.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMenu()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createMenu$Response(params?: CreateMenu$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createMenu(this.http, this.rootUrl, params, context);
  }

  /**
   * Create menu for venue.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMenu$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createMenu(params?: CreateMenu$Params, context?: HttpContext): Observable<void> {
    return this.createMenu$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createMenuWithCategories()` */
  static readonly CreateMenuWithCategoriesPath = '/api/gmn/Menu/createmenuwithcategories';

  /**
   * Create menu with categories.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMenuWithCategories()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createMenuWithCategories$Response(params?: CreateMenuWithCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createMenuWithCategories(this.http, this.rootUrl, params, context);
  }

  /**
   * Create menu with categories.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMenuWithCategories$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createMenuWithCategories(params?: CreateMenuWithCategories$Params, context?: HttpContext): Observable<void> {
    return this.createMenuWithCategories$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addCategoryToMenu()` */
  static readonly AddCategoryToMenuPath = '/api/gmn/Menu/addcategorytomenu';

  /**
   * Append existing company category to the menu.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addCategoryToMenu()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addCategoryToMenu$Response(params?: AddCategoryToMenu$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addCategoryToMenu(this.http, this.rootUrl, params, context);
  }

  /**
   * Append existing company category to the menu.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addCategoryToMenu$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addCategoryToMenu(params?: AddCategoryToMenu$Params, context?: HttpContext): Observable<void> {
    return this.addCategoryToMenu$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createCategory()` */
  static readonly CreateCategoryPath = '/api/gmn/Menu/createcategory';

  /**
   * Create menu category for company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCategory()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createCategory$Response(params?: CreateCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * Create menu category for company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCategory$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createCategory(params?: CreateCategory$Params, context?: HttpContext): Observable<void> {
    return this.createCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createSubCategory()` */
  static readonly CreateSubCategoryPath = '/api/gmn/Menu/createsubcategory';

  /**
   * Create menu sub category for company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSubCategory()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createSubCategory$Response(params?: CreateSubCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createSubCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * Create menu sub category for company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSubCategory$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createSubCategory(params?: CreateSubCategory$Params, context?: HttpContext): Observable<void> {
    return this.createSubCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createMenuItem()` */
  static readonly CreateMenuItemPath = '/api/gmn/Menu/createmenuitem';

  /**
   * Create menu item for the company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMenuItem()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createMenuItem$Response(params?: CreateMenuItem$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createMenuItem(this.http, this.rootUrl, params, context);
  }

  /**
   * Create menu item for the company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMenuItem$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createMenuItem(params?: CreateMenuItem$Params, context?: HttpContext): Observable<void> {
    return this.createMenuItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateMenu()` */
  static readonly UpdateMenuPath = '/api/gmn/Menu/updatemenu';

  /**
   * Update menu for venue.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMenu()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateMenu$Response(params?: UpdateMenu$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateMenu(this.http, this.rootUrl, params, context);
  }

  /**
   * Update menu for venue.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMenu$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateMenu(params?: UpdateMenu$Params, context?: HttpContext): Observable<void> {
    return this.updateMenu$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateMenuWithCategories()` */
  static readonly UpdateMenuWithCategoriesPath = '/api/gmn/Menu/updatemenuwithcategories';

  /**
   * Update menu with menu structure.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMenuWithCategories()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateMenuWithCategories$Response(params?: UpdateMenuWithCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateMenuWithCategories(this.http, this.rootUrl, params, context);
  }

  /**
   * Update menu with menu structure.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMenuWithCategories$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateMenuWithCategories(params?: UpdateMenuWithCategories$Params, context?: HttpContext): Observable<void> {
    return this.updateMenuWithCategories$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateCategory()` */
  static readonly UpdateCategoryPath = '/api/gmn/Menu/updatecategory';

  /**
   * Update menu category for company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCategory()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateCategory$Response(params?: UpdateCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * Update menu category for company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCategory$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateCategory(params?: UpdateCategory$Params, context?: HttpContext): Observable<void> {
    return this.updateCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateSubCategory()` */
  static readonly UpdateSubCategoryPath = '/api/gmn/Menu/updatesubcategory';

  /**
   * Update menu sub category for the company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSubCategory()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateSubCategory$Response(params?: UpdateSubCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateSubCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * Update menu sub category for the company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSubCategory$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateSubCategory(params?: UpdateSubCategory$Params, context?: HttpContext): Observable<void> {
    return this.updateSubCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateMenuItem()` */
  static readonly UpdateMenuItemPath = '/api/gmn/Menu/updatemenuitem';

  /**
   * Update menu item for the company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMenuItem()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateMenuItem$Response(params?: UpdateMenuItem$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateMenuItem(this.http, this.rootUrl, params, context);
  }

  /**
   * Update menu item for the company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMenuItem$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateMenuItem(params?: UpdateMenuItem$Params, context?: HttpContext): Observable<void> {
    return this.updateMenuItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteMenu()` */
  static readonly DeleteMenuPath = '/api/gmn/Menu/deletemenu';

  /**
   * Delete existing menu for venue.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteMenu()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteMenu$Response(params?: DeleteMenu$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteMenu(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete existing menu for venue.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteMenu$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteMenu(params?: DeleteMenu$Params, context?: HttpContext): Observable<void> {
    return this.deleteMenu$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteCategory()` */
  static readonly DeleteCategoryPath = '/api/gmn/Menu/deletecategory';

  /**
   * Delete menu category for company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCategory()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteCategory$Response(params?: DeleteCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete menu category for company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCategory$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteCategory(params?: DeleteCategory$Params, context?: HttpContext): Observable<void> {
    return this.deleteCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteSubCategory()` */
  static readonly DeleteSubCategoryPath = '/api/gmn/Menu/deletesubcategory';

  /**
   * Delete menu sub category for company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSubCategory()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteSubCategory$Response(params?: DeleteSubCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteSubCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete menu sub category for company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSubCategory$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteSubCategory(params?: DeleteSubCategory$Params, context?: HttpContext): Observable<void> {
    return this.deleteSubCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteMenuItem()` */
  static readonly DeleteMenuItemPath = '/api/gmn/Menu/deletemenuitem';

  /**
   * Delete menu item for company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteMenuItem()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteMenuItem$Response(params?: DeleteMenuItem$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteMenuItem(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete menu item for company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteMenuItem$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deleteMenuItem(params?: DeleteMenuItem$Params, context?: HttpContext): Observable<void> {
    return this.deleteMenuItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listCategoryForCompany()` */
  static readonly ListCategoryForCompanyPath = '/api/gmn/Menu/listcategoryforcompany';

  /**
   * List categories for company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listCategoryForCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCategoryForCompany$Response(params?: ListCategoryForCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listCategoryForCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * List categories for company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listCategoryForCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCategoryForCompany(params?: ListCategoryForCompany$Params, context?: HttpContext): Observable<void> {
    return this.listCategoryForCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listCategoryForMenu()` */
  static readonly ListCategoryForMenuPath = '/api/gmn/Menu/listcategoryformenu';

  /**
   * List categories for menu.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listCategoryForMenu()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCategoryForMenu$Response(params?: ListCategoryForMenu$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listCategoryForMenu(this.http, this.rootUrl, params, context);
  }

  /**
   * List categories for menu.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listCategoryForMenu$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCategoryForMenu(params?: ListCategoryForMenu$Params, context?: HttpContext): Observable<void> {
    return this.listCategoryForMenu$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listSubCategoryForCompany()` */
  static readonly ListSubCategoryForCompanyPath = '/api/gmn/Menu/listsubcategoryforcompany';

  /**
   * List Sub Categories for company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listSubCategoryForCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSubCategoryForCompany$Response(params?: ListSubCategoryForCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listSubCategoryForCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * List Sub Categories for company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listSubCategoryForCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSubCategoryForCompany(params?: ListSubCategoryForCompany$Params, context?: HttpContext): Observable<void> {
    return this.listSubCategoryForCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listItemsForCompany()` */
  static readonly ListItemsForCompanyPath = '/api/gmn/Menu/listitemsforcompany';

  /**
   * Get Menu items for company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listItemsForCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  listItemsForCompany$Response(params?: ListItemsForCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listItemsForCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Menu items for company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listItemsForCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listItemsForCompany(params?: ListItemsForCompany$Params, context?: HttpContext): Observable<void> {
    return this.listItemsForCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listSubCategoryForCategory()` */
  static readonly ListSubCategoryForCategoryPath = '/api/gmn/Menu/listsubcategoryforcategory';

  /**
   * List all sub categories for some category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listSubCategoryForCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSubCategoryForCategory$Response(params?: ListSubCategoryForCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listSubCategoryForCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * List all sub categories for some category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listSubCategoryForCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listSubCategoryForCategory(params?: ListSubCategoryForCategory$Params, context?: HttpContext): Observable<void> {
    return this.listSubCategoryForCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listItemsForCategory()` */
  static readonly ListItemsForCategoryPath = '/api/gmn/Menu/listitemsforcategory';

  /**
   * List items for category from company menu.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listItemsForCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  listItemsForCategory$Response(params?: ListItemsForCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listItemsForCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * List items for category from company menu.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listItemsForCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listItemsForCategory(params?: ListItemsForCategory$Params, context?: HttpContext): Observable<void> {
    return this.listItemsForCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listItemsForSubCategory()` */
  static readonly ListItemsForSubCategoryPath = '/api/gmn/Menu/listitemsforsubcategory';

  /**
   * List items for sub category from company menu.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listItemsForSubCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  listItemsForSubCategory$Response(params?: ListItemsForSubCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listItemsForSubCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * List items for sub category from company menu.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listItemsForSubCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listItemsForSubCategory(params?: ListItemsForSubCategory$Params, context?: HttpContext): Observable<void> {
    return this.listItemsForSubCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `viewMenu_2()` */
  static readonly ViewMenu_2Path = '/api/gmn/Menu/viewmenu';

  /**
   * Get menu for Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `viewMenu_2()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewMenu_2$Response(params?: ViewMenu_2$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return viewMenu_2(this.http, this.rootUrl, params, context);
  }

  /**
   * Get menu for Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `viewMenu_2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewMenu_2(params?: ViewMenu_2$Params, context?: HttpContext): Observable<void> {
    return this.viewMenu_2$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `viewCategory()` */
  static readonly ViewCategoryPath = '/api/gmn/Menu/viewcategory';

  /**
   * Get menu category details for Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `viewCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewCategory$Response(params?: ViewCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return viewCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * Get menu category details for Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `viewCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewCategory(params?: ViewCategory$Params, context?: HttpContext): Observable<void> {
    return this.viewCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `viewSubCategory()` */
  static readonly ViewSubCategoryPath = '/api/gmn/Menu/viewsubcategory';

  /**
   * Get menu sub category details for Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `viewSubCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewSubCategory$Response(params?: ViewSubCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return viewSubCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * Get menu sub category details for Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `viewSubCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewSubCategory(params?: ViewSubCategory$Params, context?: HttpContext): Observable<void> {
    return this.viewSubCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `viewMenuItem()` */
  static readonly ViewMenuItemPath = '/api/gmn/Menu/viewmenuitem';

  /**
   * Get menu details for id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `viewMenuItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewMenuItem$Response(params?: ViewMenuItem$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return viewMenuItem(this.http, this.rootUrl, params, context);
  }

  /**
   * Get menu details for id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `viewMenuItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  viewMenuItem(params?: ViewMenuItem$Params, context?: HttpContext): Observable<void> {
    return this.viewMenuItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listCurrenciesForMenu()` */
  static readonly ListCurrenciesForMenuPath = '/api/gmn/Menu/listcurrenciesformenu';

  /**
   * List allcurrencies and default currency related to the country of the company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listCurrenciesForMenu()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCurrenciesForMenu$Response(params?: ListCurrenciesForMenu$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listCurrenciesForMenu(this.http, this.rootUrl, params, context);
  }

  /**
   * List allcurrencies and default currency related to the country of the company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listCurrenciesForMenu$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCurrenciesForMenu(params?: ListCurrenciesForMenu$Params, context?: HttpContext): Observable<void> {
    return this.listCurrenciesForMenu$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getDefaultCurrency()` */
  static readonly GetDefaultCurrencyPath = '/api/gmn/Menu/getdefaultcurrency';

  /**
   * Get default currency for country related with company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDefaultCurrency()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDefaultCurrency$Response(params?: GetDefaultCurrency$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getDefaultCurrency(this.http, this.rootUrl, params, context);
  }

  /**
   * Get default currency for country related with company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDefaultCurrency$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDefaultCurrency(params?: GetDefaultCurrency$Params, context?: HttpContext): Observable<void> {
    return this.getDefaultCurrency$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addMenuToVenues()` */
  static readonly AddMenuToVenuesPath = '/api/gmn/Menu/addmenutovenues';

  /**
   * Assign menu to many venues.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addMenuToVenues()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addMenuToVenues$Response(params?: AddMenuToVenues$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addMenuToVenues(this.http, this.rootUrl, params, context);
  }

  /**
   * Assign menu to many venues.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addMenuToVenues$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  addMenuToVenues(params?: AddMenuToVenues$Params, context?: HttpContext): Observable<void> {
    return this.addMenuToVenues$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listAllMenus_1()` */
  static readonly ListAllMenus_1Path = '/api/gmn/Menu/listallmenus';

  /**
   * List all menues for general menager company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAllMenus_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllMenus_1$Response(params?: ListAllMenus_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listAllMenus_1(this.http, this.rootUrl, params, context);
  }

  /**
   * List all menues for general menager company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAllMenus_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllMenus_1(params?: ListAllMenus_1$Params, context?: HttpContext): Observable<void> {
    return this.listAllMenus_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listAllTaxRates()` */
  static readonly ListAllTaxRatesPath = '/api/gmn/Menu/listalltaxrates';

  /**
   * List all tax rates for general menager company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAllTaxRates()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllTaxRates$Response(params?: ListAllTaxRates$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listAllTaxRates(this.http, this.rootUrl, params, context);
  }

  /**
   * List all tax rates for general menager company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAllTaxRates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllTaxRates(params?: ListAllTaxRates$Params, context?: HttpContext): Observable<void> {
    return this.listAllTaxRates$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createTaxRate()` */
  static readonly CreateTaxRatePath = '/api/gmn/Menu/createtaxrate';

  /**
   * Create Tax rate.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTaxRate()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createTaxRate$Response(params?: CreateTaxRate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createTaxRate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Tax rate.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTaxRate$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createTaxRate(params?: CreateTaxRate$Params, context?: HttpContext): Observable<void> {
    return this.createTaxRate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTaxRateDetails()` */
  static readonly GetTaxRateDetailsPath = '/api/gmn/Menu/gettaxratedetails';

  /**
   * Get Tax Rate Details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTaxRateDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTaxRateDetails$Response(params?: GetTaxRateDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getTaxRateDetails(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Tax Rate Details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTaxRateDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTaxRateDetails(params?: GetTaxRateDetails$Params, context?: HttpContext): Observable<void> {
    return this.getTaxRateDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateTaxRate()` */
  static readonly UpdateTaxRatePath = '/api/gmn/Menu/updatetaxrate';

  /**
   * Update Tax rate.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTaxRate()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateTaxRate$Response(params?: UpdateTaxRate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateTaxRate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Tax rate.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTaxRate$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateTaxRate(params?: UpdateTaxRate$Params, context?: HttpContext): Observable<void> {
    return this.updateTaxRate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteTaxRate()` */
  static readonly DeleteTaxRatePath = '/api/gmn/Menu/deletetaxrate';

  /**
   * Delete Tax rate.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTaxRate()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTaxRate$Response(params?: DeleteTaxRate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTaxRate(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Tax rate.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTaxRate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTaxRate(params?: DeleteTaxRate$Params, context?: HttpContext): Observable<void> {
    return this.deleteTaxRate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listTaxRatesForCombo()` */
  static readonly ListTaxRatesForComboPath = '/api/gmn/Menu/listtaxratesforcombo';

  /**
   * List TaxRates for combo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTaxRatesForCombo()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTaxRatesForCombo$Response(params?: ListTaxRatesForCombo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listTaxRatesForCombo(this.http, this.rootUrl, params, context);
  }

  /**
   * List TaxRates for combo.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listTaxRatesForCombo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTaxRatesForCombo(params?: ListTaxRatesForCombo$Params, context?: HttpContext): Observable<void> {
    return this.listTaxRatesForCombo$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listAllSubVenuesForCombo()` */
  static readonly ListAllSubVenuesForComboPath = '/api/gmn/Menu/listallsubvenuesforcombo';

  /**
   * List all subvenues for combo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAllSubVenuesForCombo()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllSubVenuesForCombo$Response(params?: ListAllSubVenuesForCombo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listAllSubVenuesForCombo(this.http, this.rootUrl, params, context);
  }

  /**
   * List all subvenues for combo.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAllSubVenuesForCombo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllSubVenuesForCombo(params?: ListAllSubVenuesForCombo$Params, context?: HttpContext): Observable<void> {
    return this.listAllSubVenuesForCombo$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
